/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Action_Intervention_StartInputs */

const en_ticket_action_intervention_start = /** @type {(inputs: Ticket_Action_Intervention_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervention Start`)
};

const ja_ticket_action_intervention_start = /** @type {(inputs: Ticket_Action_Intervention_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作業開始`)
};

const fr_ticket_action_intervention_start = /** @type {(inputs: Ticket_Action_Intervention_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrer l'intervention`)
};

const de_ticket_action_intervention_start = /** @type {(inputs: Ticket_Action_Intervention_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einsatz starten`)
};

/**
* | output |
* | --- |
* | "Intervention Start" |
*
* @param {Ticket_Action_Intervention_StartInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_action_intervention_start = /** @type {((inputs?: Ticket_Action_Intervention_StartInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Action_Intervention_StartInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_action_intervention_start(inputs)
	if (locale === "ja") return ja_ticket_action_intervention_start(inputs)
	if (locale === "fr") return fr_ticket_action_intervention_start(inputs)
	return de_ticket_action_intervention_start(inputs)
});